import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import { CTA, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { COURSE_LEAVE } from '../../../../app/redux/actions/coursedetails';
import routes from '../../../../routes';

export const ModalLeaveCourseId = 'ModalLeaveCourse';

const ModalLeaveCourse = ({
  mediaIsPhone,
  id,
  title,
  formDetailsPage = false,
  type = 'course',
  modalClose,
  leaveCourse,
}) => {
  const scrollableAreaRef = useRef(null);
  const navigate = useNavigate();

  return (
    <Modal
      title="Abbandona "
      modalId={ModalLeaveCourseId}
      scrollableAreaRef={scrollableAreaRef}
      compact
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ maxWidth: '578px' }}
      >
        <Text type="h3" mb={16}>
          Sei sicuro di voler abbandonare{' '}
          {type === 'event' ? "l'evento" : 'il corso'} “{title}”?
        </Text>
        <Text type="b4">
          {type === 'event'
            ? "Cliccando su “conferma” non potrai partecipare all'evento "
            : 'Cliccando su “conferma” verranno eliminati tutti i progressi maturati per il corso '}
          “{title}”.
        </Text>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="conferma"
          fullsize={mediaIsPhone}
          onClick={() => {
            if (formDetailsPage) navigate(routes.home.path);
            leaveCourse(id);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalLeaveCourse.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  id: PropTypes.number,
  title: PropTypes.string,
  type: PropTypes.string,
  formDetailsPage: PropTypes.bool,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  leaveCourse: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { id, title, type, formDetailsPage } = state.app.modal.payload;
      return { id, title, type, formDetailsPage };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      leaveCourse: (id) => dispatch({ type: COURSE_LEAVE._REQUEST, id }),
    })
  ),
  withMediaQueries
)(ModalLeaveCourse);
